import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IInsuranceProgramsState, IListProgram } from './types/InsurancePrograms-interface'

const ProgramsListState = (state: RootState): IInsuranceProgramsState => state.insuranceProgramsList

export const ProgramsList = createSelector(
    [ProgramsListState],
    (state): IListProgram[] => state.listProgram,
)
export const CountProgramsList = createSelector(
    [ProgramsListState],
    (state): number => state.ProgramCount,
)
export const LoadingProgramsList = createSelector(
    [ProgramsListState],
    (state): boolean => state.isLoadingListProgram,
)
export const ErrorProgramsList = createSelector(
    [ProgramsListState],
    (state): string[] => state.errorListProgram,
)

export const LastFetchProgramsList = createSelector(
    [ProgramsListState],
    (state): null | number => state.lastFetchTime,
)

export const ContractsIDList = createSelector(
    [ProgramsListState],
    (state): string[] | [] => state.contractsID,
)

export const CurrentPage = createSelector(
    [ProgramsListState],
    (state): number => state.currentPage,
)

export const CurrentPageInCase = createSelector(
    [ProgramsListState],
    (state): number => state.currentPageInCase,
)